module.exports = __webpack_public_path__ + "static/img/tonica.66e0cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/tonica.png
// module id = Hd1F
// module chunks = 0